"use strict";
// (C) 2019-2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomExecutionFactory = void 0;
var tslib_1 = require("tslib");
var execution_1 = require("../toolkit/execution");
var sdk_model_1 = require("@gooddata/sdk-model");
var sdk_backend_spi_1 = require("@gooddata/sdk-backend-spi");
var isEqual_1 = tslib_1.__importDefault(require("lodash/isEqual"));
/**
 * @internal
 */
var CustomExecutionFactory = /** @class */ (function (_super) {
    tslib_1.__extends(CustomExecutionFactory, _super);
    function CustomExecutionFactory(workspace, config, state) {
        var _this = _super.call(this, workspace) || this;
        _this.config = config;
        _this.state = state;
        _this.forDefinition = function (def) {
            return new CustomPreparedExecution(def, _this, _this.config, _this.state);
        };
        return _this;
    }
    return CustomExecutionFactory;
}(execution_1.AbstractExecutionFactory));
exports.CustomExecutionFactory = CustomExecutionFactory;
/**
 * @internal
 */
var CustomPreparedExecution = /** @class */ (function () {
    function CustomPreparedExecution(definition, executionFactory, config, state) {
        var _this = this;
        this.definition = definition;
        this.executionFactory = executionFactory;
        this.config = config;
        this.state = state;
        this.execute = function () {
            var authApiCall = _this.state.authApiCall;
            return authApiCall(function (client) {
                var context = {
                    config: _this.config,
                    execution: _this,
                    resultFactory: _this.resultFactory,
                    state: _this.state,
                    client: client,
                };
                return _this.config.resultProvider(context);
            });
        };
        this.explain = function () {
            console.warn("Backend does not support explain mode");
            return {
                data: function () { return Promise.reject(new Error("Backend does not support explain mode data call.")); },
                download: function () { return Promise.resolve(); },
            };
        };
        this.withDimensions = function () {
            var dimsOrGen = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                dimsOrGen[_i] = arguments[_i];
            }
            return _this.executionFactory.forDefinition(sdk_model_1.defWithDimensions.apply(void 0, tslib_1.__spreadArrays([_this.definition], dimsOrGen)));
        };
        this.withSorting = function () {
            var items = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                items[_i] = arguments[_i];
            }
            return _this.executionFactory.forDefinition(sdk_model_1.defWithSorting(_this.definition, items));
        };
        this.withDateFormat = function (dateFormat) {
            return _this.executionFactory.forDefinition(sdk_model_1.defWithDateFormat(_this.definition, dateFormat));
        };
        this.withExecConfig = function (config) {
            return _this.executionFactory.forDefinition(sdk_model_1.defWithExecConfig(_this.definition, config));
        };
        this.equals = function (other) {
            return isEqual_1.default(_this.definition, other.definition);
        };
        this.fingerprint = function () {
            if (!_this._fingerprint) {
                _this._fingerprint = sdk_model_1.defFingerprint(_this.definition);
            }
            return _this._fingerprint;
        };
        this.resultFactory = function (dimensions, fingerprint) {
            return new CustomExecutionResult(dimensions, fingerprint, _this, _this.config, _this.state);
        };
    }
    return CustomPreparedExecution;
}());
/**
 * @internal
 */
var CustomExecutionResult = /** @class */ (function () {
    function CustomExecutionResult(dimensions, _fingerprint, execution, config, state) {
        var _this = this;
        this.dimensions = dimensions;
        this._fingerprint = _fingerprint;
        this.execution = execution;
        this.config = config;
        this.state = state;
        this.readAll = function () {
            return _this.state.authApiCall(function (client) {
                if (!_this.config.dataProvider) {
                    throw new sdk_backend_spi_1.NotImplemented("custom backend does not specify dataProvider");
                }
                var context = {
                    config: _this.config,
                    state: _this.state,
                    result: _this,
                    client: client,
                };
                return _this.config.dataProvider(context);
            });
        };
        this.readWindow = function (offset, size) {
            return _this.state.authApiCall(function (client) {
                if (!_this.config.dataProvider) {
                    throw new sdk_backend_spi_1.NotImplemented("custom backend does not specify dataProvider");
                }
                var context = {
                    config: _this.config,
                    state: _this.state,
                    result: _this,
                    window: {
                        offset: offset,
                        size: size,
                    },
                    client: client,
                };
                return _this.config.dataProvider(context);
            });
        };
        this.transform = function () {
            return _this.execution;
        };
        this.equals = function (other) {
            return _this._fingerprint === other.fingerprint();
        };
        this.fingerprint = function () {
            return _this._fingerprint;
        };
        this.export = function (_options) {
            throw new sdk_backend_spi_1.NotSupported("exports from custom backend are not supported");
        };
        this.definition = execution.definition;
    }
    return CustomExecutionResult;
}());
//# sourceMappingURL=execution.js.map